<div class='container loading'>
    <div class='img-container'>
        <div class='img'>
        </div>
    </div>
    <div class='content'>
        <div class='stripe small-stripe'>
        </div>
        <div class='stripe medium-stripe'>
        </div>
        <div class='stripe long-stripe'>
        </div>
    </div>
</div>